// extracted by mini-css-extract-plugin
module.exports = {"layoutPdpa":"AcceptPdpa_layoutPdpa__n3rzE","btnAccept":"AcceptPdpa_btnAccept__zHdlm"};